import type { ParsedSiteFeed, DevicesOnSite } from "../types";

export default function getDevicesOnSite(
  parsedSiteFeeds: ParsedSiteFeed[] | undefined
): DevicesOnSite {
  const raw = parsedSiteFeeds ?? [];
  return raw.map((distBoard) => {
    const feedsArray: ParsedSiteFeed[] = Array.isArray(distBoard.feeds) ? distBoard.feeds : (Object.values(distBoard?.feeds ?? {}) as ParsedSiteFeed[]);
    return {
      id: distBoard?.id?.toString() ?? "",
      label: distBoard?.label ?? "",
      maxOutput: distBoard?.ratedMaximumVoltageOutput?.integerValue ?? 0,
      circuits: feedsArray
        .filter((f) => (f as ParsedSiteFeed).type === "circuit")
        .map((circuitFeed) => ({
          id: circuitFeed.id?.toString() ?? "",
          label: circuitFeed.label ?? "",
          maxOutput: circuitFeed.ratedMaximumVoltageOutput?.integerValue ?? 0,
          chargerSerials:
            (circuitFeed.feeds != null && Array.isArray(circuitFeed.feeds)
              ? circuitFeed.feeds.filter((cf) => (cf as ParsedSiteFeed).type === "charger").map((cf) => (cf as ParsedSiteFeed).label ?? "")
              : []) ?? [],
        })),
      subDistBoards: feedsArray
        .filter((f) => (f as ParsedSiteFeed).type === "subDistBoard")
        .map((subDistBoardFeed) => {
          const subFeeds: ParsedSiteFeed[] = Array.isArray(subDistBoardFeed.feeds) ? subDistBoardFeed.feeds : (Object.values(subDistBoardFeed?.feeds ?? {}) as ParsedSiteFeed[]);
          return {
            id: subDistBoardFeed.id?.toString() ?? "",
            label: subDistBoardFeed.label ?? "",
            maxOutput: subDistBoardFeed.ratedMaximumVoltageOutput?.integerValue ?? 0,
            circuits: subFeeds
              .filter((f) => (f as ParsedSiteFeed).type === "circuit")
              .map((circuitFeed) => ({
                id: (circuitFeed as ParsedSiteFeed).id?.toString() ?? "",
                label: (circuitFeed as ParsedSiteFeed).label ?? "",
                maxOutput: (circuitFeed as ParsedSiteFeed).ratedMaximumVoltageOutput?.integerValue ?? 0,
                chargerSerials:
                  Array.isArray((circuitFeed as ParsedSiteFeed).feeds)
                    ? (circuitFeed as ParsedSiteFeed).feeds!.filter((cf) => (cf as ParsedSiteFeed).type === "charger").map((cf) => (cf as ParsedSiteFeed).label ?? "")
                    : [],
              })),
            chargerSerials:
              Array.isArray(subDistBoardFeed.feeds)
                ? subDistBoardFeed.feeds.filter((f) => (f as ParsedSiteFeed).type === "charger").map((f) => (f as ParsedSiteFeed).label ?? "")
                : [],
          };
        }),
      chargerSerials:
        Array.isArray(distBoard.feeds)
          ? distBoard.feeds.filter((f) => f.type === "charger").map((f) => f.label ?? "")
          : [],
    };
  });
}
